export declare let __webpack_public_path__;

__webpack_public_path__ =  process.env.NODE_ENV === 'development' ? '/' : window.location.origin + '/content/';
